import { supabase } from '../clients/supabaseClient';

export type PickerStatsSummary = {
    picker_id: string;
    picker_first_name: string;
    picker_last_name: string;
    assigned: number;
    completed: number;
    cancelled: number;
    in_progress: number;
    total_items_scanned: number;
    total_missing: number;
    avg_pick_duration_seconds: number | null;
    avg_items_per_minute: number | null;
};

export type PickerSessionDetail = {
    picking_session_id: string;
    order_id: string;
    order_reference: string;
    picker_id: string;
    session_status: string;
    assigned_at: string | null;
    started_at: string | null;
    completed_at: string | null;
    time_to_start_seconds: number | null;
    pick_duration_seconds: number | null;
    items_scanned: number;
    items_required: number;
    missing_count: number;
    items_per_minute: number | null;
};

export async function fetchAdminPickerStats(
    startDate: string,
    endDate: string
): Promise<PickerStatsSummary[]> {
    const { data, error } = await supabase.functions.invoke('get-admin-picker-stats', {
        body: { start_date: startDate, end_date: endDate },
    });
    if (error) throw error;
    if (data?.error) throw new Error(data.error);
    return (data?.pickers ?? []) as PickerStatsSummary[];
}

export async function fetchAdminPickerDetail(
    pickerId: string,
    startDate: string,
    endDate: string
): Promise<PickerSessionDetail[]> {
    const { data, error } = await supabase.functions.invoke('get-admin-picker-detail', {
        body: { picker_id: pickerId, start_date: startDate, end_date: endDate },
    });
    if (error) throw error;
    if (data?.error) throw new Error(data.error);
    return (data?.sessions ?? []) as PickerSessionDetail[];
}
